
import Vue from "vue";
import AppSidebarKeyValueList, { ISidebarKeyValueRow } from "./SidebarKeyValueList.vue";
import { CrmService } from "@/services/crm-service";
import { DossierService } from "@/services/dossier-service";
import CrmStatus from "@/models/crm/crm-status";
import { printLocalDate, printLocalDateTime } from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			statuses: [] as CrmStatus[]
		};
	},
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		statusName():string {
			if (this.item.Status && this.item.Status.ID) return this.item.Status.Name;
			let status = this.statuses.find(s=>s.ID == this.item.StatusID);
			return status ? status.Name : "";
		},
		priorityName():string {
			return this.$t(`components.crm.priorities.${this.item.Priority}`).toString();
		},
		priorityBadge():"success" | "danger" | "neutral" {
			if (this.item.Priority == 3) return "danger";
			if (this.item.Priority == 1) return "success";
			return "neutral";
		},
		assignedNames():string {
			let users:any[] = this.item.AssignedUsers || [];
			return users.map(a=>DossierService.getUser(a.UserID).getUserFullName()).filter(n=>n).join(", ");
		},
		creatorName():string {
			if (!this.item.CreatorID) return "";
			return DossierService.getUser(this.item.CreatorID).getUserFullName();
		},
		scheduled():string {
			if (!this.item.TimeSheduled) return "";
			return printLocalDateTime(this.item.TimeSheduled);
		},
		isScheduledInPast():boolean {
			if (!this.item.TimeSheduled) return false;
			return new Date(this.item.TimeSheduled).getTime() < Date.now();
		},
		rows():ISidebarKeyValueRow[] {
			let t = (key:string)=>this.$ct(`sidebar.crm-overview.${key}`).toString();
			return [
				{label: t("status"), value: this.statusName},
				{label: t("priority"), value: this.priorityName, badge: this.priorityBadge},
				{label: t("scheduled"), value: this.scheduled, warning: this.isScheduledInPast},
				{label: t("assigned"), value: this.assignedNames},
				{label: t("created"), value: this.item.TimeStamp ? printLocalDate(this.item.TimeStamp) : ""},
				{label: t("creator"), value: this.creatorName, hideIfEmpty: true}
			];
		},
		summary():string {
			return [this.statusName, this.scheduled].filter(v=>v).join(" · ");
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	async created(){
		if (this.item.Status && this.item.Status.ID) return;
		try {
			this.statuses = await CrmService.getCrmStatuses();
		} catch (err) {
			this.statuses = [];
		}
	},
	components: {
		AppSidebarKeyValueList
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
